import { createFileRoute } from '@tanstack/react-router';
import { calibrationQueryOptions } from '@/features/calibration/api';
import { CalibrationPage } from '@/features/calibration/CalibrationPage';

export const Route = createFileRoute('/_auth/calibration')({
  // Préchargement ; les erreurs sont rendues par la page (`ErrorState`).
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(calibrationQueryOptions()).catch(() => undefined),
  component: CalibrationPage,
});
